<template>
  <b-list-group class="pt-6 the-navigation w-100">
    <b-list-group-item
      v-for="(link, index) in links"
      :key="index"
      :data-test="`nav-item-${link.name}`"
      @click.left="navigateTo(link.routerName)"
      @click.right="openInNewTab(link.routerName)"
      class="list-group-item"
      :active="isActive(link.routerName)"
      type="button"
    >
      <i
        class="fal pr-2"
        :class="`fa-${link.icon}`"
      />
      {{ link.name }}
    </b-list-group-item>
    <b-button
      variant="footer"
      class="mt-5 list-group-item list-single-item text-left"
      data-test="nav-item-signout"
      @click="signout"
    >
      <i class="fal pr-2 fa-sign-out" />
      Sign Out
    </b-button>
    <b-button
      variant="link"
      class="list-group-item list-single-item text-left"
      href="mailto:support@smartology.net"
      target="_blank"
    >
      <i class="fal pr-2 fa-question-circle" />
      Help
    </b-button>
  </b-list-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as authenticationTypes from '@/modules/authentication/store/types';
import * as accountTypes from '@/modules/account/store/types';
import feature from 'vue-feature-toggle';
import urlHelper from '@/core/mixins/urlHelper';

export default {
  mixins: [
    urlHelper,
  ],
  data() {
    return {
      links: [
        {
          icon: 'bullhorn',
          routerName: 'dashboard',
          name: 'Campaigns',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('account', [
      accountTypes.GET_IS_MANAGED_ACCOUNT,
    ]),
    currentRouteName() {
      return this.$route.name;
    },
    isManagedCampaign() {
      return feature.isVisible('MANAGED_CAMPAIGNS');
    },
  },
  methods: {
    ...mapActions('authentication', [
      authenticationTypes.SIGN_OUT,
    ]),
    async signout() {
      await this.SIGN_OUT();
      this.navigateURLRefresh('login');
    },
    navigateTo(routerName) {
      this.navigateURLRefresh(routerName);
    },
    openInNewTab(routerName) {
      this.openURLInNewTab(this.buildRoute(routerName).href);
    },
    navigateURLRefresh(routerName) {
      this.assignURLToCurrentTab(this.buildRoute(routerName).href);
    },
    buildRoute(name, params, query) {
      return this.$router.resolve({
        name: name || undefined,
        params: params || undefined,
        query: query || undefined,
      });
    },
    isActive(name) {
      return (this.currentRouteName === name);
    },
  },
  mounted() {
    if (this.isManagedCampaign) {
      if (feature.isVisible('SHOW_SELF_SERVICE_DASHBOARD')) {
        this.links.push({
          icon: 'users-rectangle',
          routerName: 'selfServiceDashboard',
          name: 'Self Service Campaigns',
        });
      }
      if (this.GET_IS_MANAGED_ACCOUNT) {
        this.links.push({
          icon: 'file-chart-column',
          routerName: 'reportsGeneratorDashboard',
          name: 'Reports',
        });
      }
      this.links.push(
        {
          icon: 'file-code',
          routerName: 'templates',
          name: 'Templates',
        },
      );
    }
  },
};
</script>
